"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideDialog = void 0;
var React = __importStar(require("react"));
var Dialog_1 = __importDefault(require("@material-ui/core/Dialog"));
var styles_1 = require("@material-ui/core/styles");
var Slide_1 = __importDefault(require("@material-ui/core/Slide"));
var styles_2 = require("../styles");
var styles = styles_1.createStyles(function (_a) {
    var palette = _a.palette, theme = __rest(_a, ["palette"]);
    var _b = styles_2.sideDialogBaseStyles(__assign({ palette: palette }, theme)), title = _b.title, content = _b.content, actions = _b.actions;
    return {
        root: {
            "& [class*='MuiDialogTitle-root']": title,
            "& [class*='MuiDialogContent-root']": content,
            "& [class*='MuiDialogActions-root']": actions,
        },
        paper: {
            maxHeight: "100%",
            margin: 0,
            border: 0,
            // Duplicate logic since JSS is only able to compute for the value
            borderLeft: function (_a) {
                var anchor = _a.anchor;
                return anchor !== "left" ? "1px solid " + palette.divider : undefined;
            },
            borderRight: function (_a) {
                var anchor = _a.anchor;
                return anchor === "left" ? "1px solid " + palette.divider : undefined;
            },
        },
        container: {
            display: "flex",
            alignItems: "stretch",
            justifyContent: function (_a) {
                var anchor = _a.anchor;
                return anchor === "left" ? "flex-start" : "flex-end";
            },
        },
    };
});
exports.SideDialog = styles_1.withStyles(styles, { name: "EuiSideDialog" })(React.forwardRef(function SideDialog(_a, ref) {
    var _b = _a.anchor, anchor = _b === void 0 ? "right" : _b, _c = _a.PaperProps, PaperProps = _c === void 0 ? {} : _c, _d = _a.TransitionComponent, TransitionComponent = _d === void 0 ? Slide_1.default : _d, _e = _a.TransitionProps, TransitionProps = _e === void 0 ? {} : _e, restProps = __rest(_a, ["anchor", "PaperProps", "TransitionComponent", "TransitionProps"]);
    return (React.createElement(Dialog_1.default, __assign({ PaperProps: __assign({ square: true }, PaperProps), TransitionComponent: TransitionComponent, TransitionProps: __assign({ direction: anchor === "left" ? "right" : "left" }, TransitionProps) // `TransitionProps` doesn't match specific transition APIs
        , ref: ref }, restProps)));
}));
//# sourceMappingURL=SideDialog.js.map